import { useState } from 'react'

import { useSelector } from 'react-redux'
import { Card } from 'antd'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionConstraint, InstitutionConstraintProperties as Properties } from '../../../utils/entities/institutionConstraints'
import useQuery from '../../../hooks/useQuery'
import { TableParameters } from '../../../utils/entities/tableParameters'
import { Order } from '../../../utils/entities/queries'
import { getAllInstitutionConstraints } from '../../../utils/api/institutionConstraints'
import InstitutionConstraintModalProvider from '../../../Providers/Forms/InstitutionConstraint/InstitutionConstraintModalProvider'
import InstitutionConstraintTable from './InstitutionConstraintsTable'
import useInstitutionConstraint from '../../../utils/api/hooks/useInstitutionConstraint'
import { resolvePromises } from '../../../utils/apiHelper'

export const Actions = Object.freeze({
  DELETE: 'DELETE_CONSTRAINT',
  TOGGLE: 'TOGGLE_CONSTRAINT'
})

const DEFAULT_TABLE_PARAMS = {
  order: new Order({ by: Properties.PROPERTY_NAME }),
  filters: ({})
}

const InstitutionConstraintsCard = () => {
  const t = useSelector(selectTranslate)

  const [tableParameters, setTableParameters] = useState(new TableParameters({ ...DEFAULT_TABLE_PARAMS }))

  const institutionConstraints = useQuery({
    request: getAllInstitutionConstraints,
    defaultParameters: new TableParameters(tableParameters).clone().toQueryParameters(),
    select: constraints => constraints.map(c => new InstitutionConstraint(c))
  })

  const constraintsHandler = useInstitutionConstraint({ callback: institutionConstraints.refetch })

  const handleTableParametersChange = tableParameters => {
    const queryParameters = new TableParameters({
      ...institutionConstraints.parameters,
      ...tableParameters
    }).toQueryParameters()

    institutionConstraints.setParameters(queryParameters)
    setTableParameters(queryParameters)
  }

  const handleAction = (...itemActionPairs) => {
    const promises = []

    for (let iPair = 0; iPair < itemActionPairs.length; iPair += 2) {
      const item = itemActionPairs[iPair]
      const action = itemActionPairs[iPair + 1]

      if (action === Actions.DELETE) {
        promises.push(constraintsHandler.delete(item))
      } else if (action === Actions.TOGGLE) {
        promises.push(constraintsHandler.toggle(item))
      }
    }

    resolvePromises(promises).then(institutionConstraints.refetch)
  }

  const propertiesToFilter = institutionConstraints.data.map(c => c[Properties.PROPERTY_NAME])

  return (
    <InstitutionConstraintModalProvider toFilter={propertiesToFilter}>
      <div className='institution-constraints-card'>
        <Card title={t('institution_constraints.cart_title')}>
          <InstitutionConstraintTable
            data={institutionConstraints.data}
            loading={institutionConstraints.loading}
            metadata={institutionConstraints.metadata}
            tableParameters={tableParameters}
            onAction={handleAction}
            onParametersChange={handleTableParametersChange}
          />
        </Card>
      </div>
    </InstitutionConstraintModalProvider>
  )
}

export default InstitutionConstraintsCard
